import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";



const TokenomicsS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.titleWrap}`}>
                    <div className={`${Styles.title}`}>{t('ТОКЕНОМИКА')}</div>
                </div>
                <div className={`${Styles.subTitle}`}>$TC Token</div>
                <ul className={`${Styles.listWrap}`}>
                    <li className={`${Styles.listWrapItem}`}>{t('Стандарт')}: BEP-20</li>
                    <li className={`${Styles.listWrapItem}`}>{t('Сеть')}: BNB Smart Chain (BSC)</li>
                </ul>
                <div className={`${Styles.note}`}>{t('TC (Time Capsule Token) — это утилитарный и инфраструктурный токен экосистемы Тайм Капсулы, развернутый в сети BEP-20 для обеспечения высокой скорости транзакций, низких комиссий и масштабируемости.')}</div>
            </div>
        </section>
    );
};

export default TokenomicsS1;